<template>
<div class="hello">
  <h1>{{ msg }}</h1>
  <p>
    For a guide and recipes on how to configure / customize this project,<br>
    check out the
    <a href="https://cli.vuejs.org" target="_blank" rel="noopener">vue-cli documentation</a>.
  </p>
  <h3>Installed CLI Plugins</h3>
  <ul>
    <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel" target="_blank" rel="noopener">babel</a></li>
    <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint" target="_blank" rel="noopener">eslint</a></li>
  </ul>
  <h3>Essential Links</h3>
  <ul>
    <li><a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a></li>
    <li><a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a></li>
    <li><a href="https://chat.vuejs.org" target="_blank" rel="noopener">Community Chat</a></li>
    <li><a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a></li>
    <li><a href="https://news.vuejs.org" target="_blank" rel="noopener">News</a></li>
  </ul>
  <h3>Ecosystem</h3>
  <ul>
    <li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
    <li><a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a></li>
    <li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
    <li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
    <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
  </ul>
  <v-btn color="primary" @click="test()">text</v-btn>
  <v-btn color="primary" @click="test2()">text post</v-btn>
  <v-btn color="primary" @click="test3()">text post 3</v-btn>
  <v-btn color="primary" @click="toPage('/page/1234')">to Page</v-btn>
  <v-btn color="primary" @click="toPage('/nest/route/12345')">to Nest Route</v-btn>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
    toPage (id) {
      this.$router.push(id)
    },
    test() {
      this.axios('https://chat-api.one.th/go_api/api/v1/getOneID/U76f5b11ab61951e5b802cfa8b1ac8a2d').then((res) => {
        console.log(res)
      }).catch(err => {
        console.log(err)
      })
    },
    test3() {
      // this.axios('https://chat-api.one.th/go_api/api/v1/getOneID/U76f5b11ab61951e5b802cfa8b1ac8a2d').then((res) => {
      //   console.log(res)
      // }).catch(err => {
      //   console.log(err)
      // })
      var axios = require('axios');
      var data = JSON.stringify({
        'bangchak_id': "MEMBER5885"
      });

      var config = {
        method: 'post',
        url: 'https://chat-manage.one.th/go_api/api/v1/get-phone-by-bangchak-id',
        headers: {
          'Authorization': 'Bearer test.tock.service',
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
        .then(function(response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    test2() {
      // this.axios('https://chat-api.one.th/go_api/api/v1/getOneID/U76f5b11ab61951e5b802cfa8b1ac8a2d').then((res) => {
      //   console.log(res)
      // }).catch(err => {
      //   console.log(err)
      // })
      var axios = require('axios');
      var data = JSON.stringify({
        "sender": "12182807784",
        "to": "24365341344"
      });

      var config = {
        method: 'post',
        url: 'https://chat-api.one.th/alpine/api/v1/gen-token-agora',
        headers: {
          'Authorization': 'Bearer test.tock.service',
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
        .then(function(response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
